import { default as axios, postWithAuthToken, } from '@/axios';
import router from '@/router';

const state = () =>
({
    user: JSON.parse(localStorage.getItem('user')),
    isAuthenticated: ['true', true].includes(localStorage.getItem('isAuthenticated')),
    accessToken: localStorage.getItem('accessToken'),
    refreshToken: localStorage.getItem('refreshToken'),
    users: [],
});

const getters = {
    user: state => state.user,
    isAuthenticated: state => state.isAuthenticated,
    isPlannerOrHigher: state => state.user && ['Administrator','Planner','Manager'].includes(state.user && state.user.role),
    isManagerOrHigher: state => state.user && ['Administrator', 'Manager'].includes(state.user && state.user.role),
    accessToken: state => state.accessToken,
    refreshToken: state => state.refreshToken,
    allUsers: state => state.users,
};

const mutations = {
    SET_USER(state, user)
    {
        state.user = user;
        localStorage.setItem('user', JSON.stringify(user));
    },
    SET_USER_AUTHENTICATED(state, value)
    {
        localStorage.setItem('isAuthenticated', value);
        state.isAuthenticated = value;
    },
    SET_TOKEN(state, {access,refresh})
    {
        state.accessToken = access;
        state.refreshToken = refresh;
        localStorage.setItem('accessToken', access);
        localStorage.setItem('refreshToken', refresh);
    },
    CLEAR_STATE(state)
    {
        localStorage.setItem('accessToken', null);
        localStorage.setItem('refreshToken', null);
        localStorage.setItem('isAuthenticated', null);
        localStorage.setItem('user', null);
        state.isAuthenticated = false;
        state.user = null;
        state.users = [];
        state.accessToken = null;
        state.refreshToken = null;
    }
};

const actions = {
    async logIn({commit}, credentials)
    {
        const response = await axios.post('api/login/', {...credentials});
        if (response.status == 200)
        {
            const {access, refresh, user} = response.data;
            commit('SET_TOKEN', {access, refresh})
            commit('SET_USER_AUTHENTICATED', true);
            commit('SET_USER', user);
        }
    },
    async registerUser(_, userInfo)
    {
        return await axios.post('api/register/', userInfo)
    },
    async requestPasswordReset(_, email)
    {
        return await axios.post('api/password-reset/', {email})
    },
    async setNewPassword(_, {password, token})
    {
        return await axios.post('api/password-reset/confirm/', {
            password: password,
            token: token,
        });
    },
    async refreshAccessToken({state, commit})
    {
        const response = await postWithAuthToken('api/token/refresh/', {
            refresh: state.refreshToken,
        });
        commit('SET_TOKEN', {refresh: state.refreshToken, access: response.data.access});
        return response.data && response.data.access;
    },
    logOut({commit})
    {
        this.reset();
        this.dispatch('setReloadRequired', true, {root: true});
        commit('CLEAR_STATE');
        if (router.history.current.name !== 'landing-page')
          router.push({name: 'landing-page'});
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
